<template>
<div>
<v-card class="mt-5">
    
        
            <v-card :loading="loading"  v-if="recherche">
                <v-card-text>
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                >
                    <h3>Votre recherche</h3>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-combobox label="Type de contrat" prepend-icon="mdi-book-outline" v-model="typeContrat" :items="$store.getters['filedata/catalogues'](12315)" item-text="libelle" item-value="id"  :rules="[rules.required]" dense></v-combobox>
                        </v-col>
                    </v-row>
                    
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-combobox label="Secteur d'activité" prepend-icon="mdi-domain" v-model="secteurActivite" :items="$store.getters['filedata/catalogues'](12427)" item-text="libelle" item-value="id"  :rules="[rules.required]" dense></v-combobox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-combobox label="Commune" autocomplete="off" prepend-icon="mdi-map-marker" v-model="commune" :items="$store.getters['formulaireCandidature/communes']"  item-text="libelle" item-value="id"  :rules="[rules.required, rules.numberRule]" dense></v-combobox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-text-field label="Objet de la demande" prepend-icon="mdi-book-edit-outline" v-model="objetDemande"  :rules="[rules.required]" dense></v-text-field>
                            <v-alert dense type="warning" color="red darken-3">
                                Merci de préciser dans l'objet de votre demande la période recherchée pour votre stage ou contrat.<br>
                                Exemple : Recherche alternance plomberie année scolaire 2021/2020
                                </v-alert>
                        </v-col>
                    </v-row>
                    
                    <h3>Candidature</h3>
                    <v-row>
                        <v-col cols="12" sm="2">
                            <v-combobox label="Civilité" prepend-icon="mdi-account" v-model="civilite" :items="$store.getters['filedata/catalogues'](204)" item-text="libelle" item-value="id"  :rules="[rules.required]" dense></v-combobox>
                        </v-col>
                        <v-col cols="12" sm="5">
                            <v-text-field label="Nom"  ref="nom" v-model="nom"  :rules="[rules.required]" dense required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="5">
                            <v-text-field label="Prénom"  ref="prenom" v-model="prenom" :rules="[rules.required]" dense required></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        
                        <v-col cols="12" sm="6">
                            <v-text-field label="Téléphone" prepend-icon="mdi-cellphone" ref="tel" v-model="tel"  :rules="[rules.required]" dense ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                            label="Email" 
                            prepend-icon="mdi-email-outline" 
                            ref="email"
                            v-model="email" 
                            :rules="[rules.required, rules.email]"
                            dense required></v-text-field>
                        </v-col>
                    </v-row>
                    <h3>CV & Lettre de motivation</h3>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-file-input
                                v-model="cv" 
                                ref="cv"
                                :rules="fileRequired"
                                accept=".pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                label="Téléchargez votre CV"
                                dense
                            ></v-file-input>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-file-input
                                v-model="lettreMotivation" 
                                ref="lettreMotivation"
                                :rules="fileRequired"
                                accept=".pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                label="Téléchargez votre lettre de motivation"
                                dense
                            ></v-file-input>
                        </v-col>
                    </v-row>
                    

                    <v-row>
                        <v-col cols="12" class="text-center">
                            <v-btn 
                        
                            @click="validerCandidature" 
                            class="btn-valider"
                            ><v-icon left>mdi-check-circle-outline</v-icon>Valider la candidature</v-btn>
                        </v-col>
                    </v-row>
                
                </v-form>
                </v-card-text>
            </v-card>
            <v-card v-if="message">
                <h3>Votre recherche</h3>
                <p>
                    Votre demande à bien été enregistrée.
                </p>

            </v-card>
        
    
</v-card>
</div>
</template>

<script>

export default {
  data () {
    return {
     valid: true,
      //id                : 0, // Id de l'offre demandé lors de l'affichage de la fiche
      loading               : true, // Indicateur de chargement
      
      communes              : [],   // Liste des communes
      
      formHasErrors         : false,
      fileRequired: [value => !!value || 'Champ requis.'],
      rules: {
            required: value => !!value || 'Required.',
            //itemRequired : value => !!value || 'Champ requis',
            
            numberRule: v  => {
                console.log("rules : " + v.id)
                
                if (!isNaN(parseFloat(v.id)) && v.id >= 0) return true;
                    return 'Veuillez choisir une commune dans la liste';
                },
            email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'E-mail invalide'
            },
        },
    }
  },
  mounted(){
    var that = this
    document.title = "Formulaire de candidature"

    this.loading = true

    Promise.all([
      this.$store.dispatch('formulaireCandidature/listeCommune'), // Télécharge les communes
      this.$store.dispatch('filedata/liste', {'DescId': '12315', 'bien': '0', 'emploi' : '0'}), // Télécharge le catalogue type de contrat
      this.$store.dispatch('filedata/liste', {'DescId': '12427', 'bien': '0', 'emploi' : '0'}), // Télécharge le catalogue secteur d'activité
      this.$store.dispatch('filedata/liste', {'DescId': '204', 'bien': '0', 'emploi' : '0'}), // Télécharge le catalogue civilite
    ])
    .then(function(){
      that.loading          = false
    })
  },
  /**
  * Rappel VueJS
  * Une computed est appelée à chaque fois qu'une des data, sur laquelle elle repose, change
  * On utilise cette fonctionnalité pour mettre à jour la liste des offres à chaque fois qu'un  change
  */
  computed : {
    /**
     * En général, on connecte les v-model à des données du composant
     * Ici on passe par des computed pour connecter ces v-model directement au state
     * ce qui permet de les garder en mémoire même si on change d'écran
     */    
    panelState              : { get(){ return this.$store.getters['formulaireCandidature/panelState']           }, set(Value){ this.$store.commit('formulaireCandidature/panelState'            , Value); }},
    commune                 : { get(){ return this.$store.getters['formulaireCandidature/commune']              }, set(Value){ this.$store.commit('formulaireCandidature/commune'               , Value); }},
    typeContrat             : { get(){ return this.$store.getters['formulaireCandidature/typeContrat']          }, set(Value){ this.$store.commit('formulaireCandidature/typeContrat'           , Value); }},
    secteurActivite         : { get(){ return this.$store.getters['formulaireCandidature/secteurActivite']      }, set(Value){ this.$store.commit('formulaireCandidature/secteurActivite'       , Value); }},
    civilite                : { get(){ return this.$store.getters['formulaireCandidature/civilite']             }, set(Value){ this.$store.commit('formulaireCandidature/civilite'              , Value); }},
    objetDemande            : { get(){ return this.$store.getters['formulaireCandidature/objetDemande']         }, set(Value){ this.$store.commit('formulaireCandidature/objetDemande'          , Value); }},
    nom                     : { get(){ return this.$store.getters['formulaireCandidature/nom']                  }, set(Value){ this.$store.commit('formulaireCandidature/nom'                   , Value); }},
    prenom                  : { get(){ return this.$store.getters['formulaireCandidature/prenom']               }, set(Value){ this.$store.commit('formulaireCandidature/prenom'                , Value); }},
    tel                     : { get(){ return this.$store.getters['formulaireCandidature/tel']                  }, set(Value){ this.$store.commit('formulaireCandidature/tel'                   , Value); }},
    email                   : { get(){ return this.$store.getters['formulaireCandidature/email']                }, set(Value){ this.$store.commit('formulaireCandidature/email'                 , Value); }},
    cv                      : { get(){ return this.$store.getters['formulaireCandidature/cv']                   }, set(Value){ this.$store.commit('formulaireCandidature/cv'                    , Value); }},
    lettreMotivation        : { get(){ return this.$store.getters['formulaireCandidature/lettreMotivation']     }, set(Value){ this.$store.commit('formulaireCandidature/lettreMotivation'      , Value); }},

    message                 : { get(){ return this.$store.getters['formulaireCandidature/message']              }, set(Value){ this.$store.commit('formulaireCandidature/message'               , Value); }},
    recherche               : { get(){ return this.$store.getters['formulaireCandidature/recherche']            }, set(Value){ this.$store.commit('formulaireCandidature/recherche'             , Value); }},

    form () {
        return {
            nom             : this.nom,
            prenom          : this.prenom,
            email           : this.email,
            tel             : this.tel,
        }
      },
  },
  methods : {
    
    /**
     * Redirige vers la fiche choisie
     */
    validerCandidature(){
       
        this.formHasErrors = false
        /*
        Object.keys(this.form).forEach(f => {
            if (!this.form[f]) this.formHasErrors = true
            
            console.log(f + " : " + this.form[f])
            this.$refs[f].validate(true)
        })
        */
        this.formHasErrors = this.$refs.form.validate()
        console.log("FormError : " + this.formHasErrors)

        if(this.formHasErrors){
            this.$store.dispatch('formulaireCandidature/envoyerCandidature')
        }
    },
  },
}
</script>

<style scoped>

    .row-pointer >>> tbody tr :hover {
        cursor: pointer;
    }

    .v-alert{
        margin-bottom: .95rem !important;
        margin-top: .95rem !important;
    }

</style>